import React from 'react';

type IconProps = {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  size?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = 24,
  color = 'currentColor',
  ...rest
}) => {
  return <IconComponent width={size} height={size} fill={color} {...rest} />;
};
